'use client';

import { c as _c } from "react/compiler-runtime";
import { Header as HeaderSparky, LayoutContainer } from '@petsmart-ui/sparky';
import type { Entry } from 'contentful';
import type { PropsWithChildren } from 'react';
import { LegacyIcon, LegacyIconName } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
import { buildPage, ComponentResolver } from '../../utils';
import { Autocomplete } from '../autocomplete';
import { LegacyAccountDropdown } from '../LegacyAccountDropdown';
import { LegacyHeaderDrawer } from '../LegacyHeaderDrawer';
import { LegacyMinicart } from '../LegacyMinicart';
import { LegacyNavAdoptions } from '../LegacyNavAdoptions';
import { LogoWrapper } from '../LogoWrapper';
import LegacyHeaderPersonIcon from './LegacyHeaderPersonIcon';
import type { LegacyHeaderProps } from './types';
import './LegacyHeader.scss';
export default function LegacyHeader(t0) {
  const $ = _c(28);
  const {
    entry,
    children
  } = t0;
  let t1;
  if ($[0] !== entry?.fields) {
    t1 = entry?.fields ?? {};
    $[0] = entry?.fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mainMenu,
    items,
    livesSaved,
    secondaryNavigation
  } = t1;
  let t2;
  if ($[2] !== items) {
    t2 = items ? buildPage(items as Entry[]) : null;
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const entries = t2;
  const t3 = secondaryNavigation as Entry;
  const t4 = livesSaved as Entry;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <HeaderSparky.Top className="legacy-header__section legacy-header__section--divide"><LayoutContainer className="legacy-header__container"><LegacyNavAdoptions secondaryNavigation={t3} livesSaved={t4} /></LayoutContainer></HeaderSparky.Top>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = secondaryNavigation as Entry;
  const t7 = mainMenu as Entry;
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <LegacyHeaderDrawer secondaryNavigation={t6} mainMenu={t7} />;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="legacy-header__logo"><LogoWrapper /></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Autocomplete className="legacy-autocomplete" productsHitPerPage={2} />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== children) {
    t11 = <div className="legacy-header__search">{t10}<div className="ai-assist">{children}</div></div>;
    $[12] = children;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="legacy-header__account"><LegacyAccountDropdown /><LegacyHeaderPersonIcon /></div>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="legacy-header__cart"><a href={NAVIGATION_URLS.legacy.storeLocator.base} title="Locate Stores" className="legacy-header__cart-pin-icon"><LegacyIcon aria-hidden="true" name={LegacyIconName.PIN} isPriority={true} size={24} /></a><LegacyMinicart /></div>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11 || $[17] !== t8) {
    t14 = <HeaderSparky.Middle className="legacy-header__section legacy-header__section" hideMenuButton={true}><LayoutContainer className="legacy-header__container" role="banner"><div className="legacy-header__banner--desktop">{t8}{t9}{t11}{t12}{t13}</div></LayoutContainer></HeaderSparky.Middle>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = mainMenu as Entry;
  let t16;
  if ($[19] !== t15) {
    t16 = <HeaderSparky.Bottom className="legacy-header__section legacy-header__section--primary" data-testid="legacy-mainmenu"><LayoutContainer className="legacy-header__container"><ComponentResolver entry={t15} /></LayoutContainer></HeaderSparky.Bottom>;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t14 || $[22] !== t16 || $[23] !== t5) {
    t17 = <HeaderSparky className="legacy-header" data-testid="legacy-header">{t5}{t14}{t16}</HeaderSparky>;
    $[21] = t14;
    $[22] = t16;
    $[23] = t5;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== entries || $[26] !== t17) {
    t18 = <>{entries}{t17}</>;
    $[25] = entries;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}